import React from 'react';
import ReactDOM from 'react-dom';
import { compose, withState, lifecycle, renderNothing } from 'recompose';
import { isLarge } from 'utils/breakpoints';

export const enhance = compose(
	withState('infoWindow', 'setInfoWindow', null),
	lifecycle({
		componentDidMount() {
			const { content, google, map, setInfoWindow, location, onClose } =
				this.props;
			if (google && map) {
				this.infoContent = document.createElement('div');
				const infoContent = this.infoContent;
				ReactDOM.render(<div>{content}</div>, infoContent);

				const viewportWidth = window.innerWidth;
				const isLargeView = isLarge(viewportWidth);
				const infoWindow = new google.maps.InfoWindow({
					content: infoContent,
					position: new google.maps.LatLng(
						location.latitude,
						location.longitude,
					),
					pixelOffset: new google.maps.Size(
						0,
						isLargeView ? 485 : 580,
					),
				});

				google.maps.event.addListener(
					infoWindow,
					'closeclick',
					onClose,
				);

				setInfoWindow(infoWindow);

				infoWindow.open(map);
			}
		},
		componentWillUnmount() {
			const { google, infoWindow, setInfoWindow } = this.props;
			if (infoWindow) {
				infoWindow.close();
				google.maps.event.clearInstanceListeners(infoWindow);
				setInfoWindow(null);
			}
			if (this.infoContent) {
				ReactDOM.unmountComponentAtNode(this.infoContent);
			}
		},
	}),
);

export default enhance(renderNothing());
